import ExcelJS from 'exceljs'
import {saveAs} from 'file-saver'
import {RequestDataType} from '../tabs/RequestsTab'

function stripHtmlTags(str) {
  return str.replace(/<\/?[^>]+(>|$)/g, '')
}

export const ExportRequests = async (requests: RequestDataType[]) => {
  for (const request of requests) {
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Requests')

    worksheet.views = [{state: 'frozen', ySplit: 1}]

    worksheet.columns = [
      {header: 'Requester Name', key: 'name', width: 20},
      {header: 'Requester Email', key: 'email', width: 20},
      {header: 'Requester Company', key: 'company', width: 40},
      {header: 'Resources', key: 'resources', width: 80},
      {header: 'Requested Date', key: 'reqDate', width: 25},
      {header: 'Status', key: 'status', width: 20},
      {header: 'Decision Made By', key: 'decisionMaker', width: 20},
      {header: 'Decision Made On', key: 'decisionMadeOn', width: 25},
    ]

    const headerRow = worksheet.getRow(1)
    headerRow.font = {bold: true, color: {argb: 'FFFFFFFF'}, size: 10}
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'FF000000'},
    }
    headerRow.height = 30
    headerRow.alignment = {horizontal: 'center'}

    for (let i = 1; i <= 11; i++) {
      const cell = headerRow.getCell(i)
      cell.font = {bold: true, color: {argb: 'FFFFFFFF'}, size: 11}
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: 'FF000000'},
      }
      cell.alignment = {horizontal: 'center', vertical: 'middle'}
    }

    const exportData = requests.map((row) => ({
      name: `${row.firstname} ${row.lastname}` || '',
      email: row.email || '',
      company: row.company || '',
      resources: row.resources.map((resource) => resource.title).join(', ') || '',
      reqDate: row.requestedDate.toDate().toDateString() || '',
      status: row.status || '',
      decisionMaker: row.decisionMadeBy?.name || '-',
      decisionMadeOn: row.decisionMadeBy?.date.toDate().toDateString() || '-',
    }))

    exportData.forEach((item) => {
      const row = worksheet.addRow(item)
      row.height = 25
      row.font = {size: 10}

      if (item.status === 'Needs Decision') {
        row.getCell('F').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'F6F6F6'},
          }
      }

      if (item.status === 'Approved') {
        row.getCell('F').fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: 'D9EAD3'},
        }
      } else if (item.status === 'Rejected') {
        row.getCell('F').fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: 'F4CCCC'},
        }
      }
    })

    const buffer = await workbook.xlsx.writeBuffer()
    const excelBlob = new Blob([buffer], {type: 'application/octet-stream'})

    saveAs(excelBlob, `requests.xlsx`)
  }
}
